import { render, staticRenderFns } from "./videoRanking.vue?vue&type=template&id=0ef3cb61&scoped=true"
import script from "./videoRanking.vue?vue&type=script&lang=js"
export * from "./videoRanking.vue?vue&type=script&lang=js"
import style0 from "./videoRanking.vue?vue&type=style&index=0&id=0ef3cb61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3cb61",
  null
  
)

export default component.exports